import { graphql, useStaticQuery } from "gatsby"

const useAllCollections = () => {
  const {
    allWpCollection: { nodes },
  } = useStaticQuery(graphql`
    {
      allWpCollection {
        nodes {
          title
          BrandCarousel {
            fieldGroupName
            description
            heading
            icon {
              altText
              gatsbyImage(
                placeholder: BLURRED
                quality: 70
                width: 230
                height: 65
                fit: OUTSIDE
                formats: [AUTO, WEBP]
              )
            }
            slider {
              image {
                altText
                gatsbyImage(height: 200, width: 200, formats: [AUTO, WEBP])
              }
            }
          }
          isBrand {
            isBrand
          }
          featuredImage {
            node {
              gatsbyImage(
                placeholder: BLURRED
                quality: 100
                width: 158
                height: 65
                fit: OUTSIDE
                formats: [AUTO, WEBP]
              )
            }
          }
        }
      }
    }
  `)
  return nodes
}

export default useAllCollections
